export default () => {
  const sliderParents = document.querySelectorAll('.js-swipe-one-slider-parent')
  
  if (sliderParents.length < 1) return
  if (document.body.clientWidth < 1000) return 

  ;[...sliderParents].forEach(sliderParent => {

    // Variables
    const slider = sliderParent.querySelector('.js-swipe-one-slider')
    const firstSlide = sliderParent.querySelector('.js-swipe-one-slide')
    const next = sliderParent.querySelector('.js-swipe-one-slider-next')
    const prev = sliderParent.querySelector('.js-swipe-one-slider-prev')
    const dots = sliderParent.querySelectorAll('.js-swipe-one-slider-dot')
    
    const slidesCount = sliderParent.querySelectorAll('.js-swipe-one-slide').length
    let slideWidth = firstSlide.offsetWidth

    let pos = 0

    // Recalculate on resize
    window.addEventListener('resize', () => {
      slideWidth = firstSlide.offsetWidth
      pos = 0
      setTransform()
      navActivity()
      dotActivity()
    })

    // Events
    prev.addEventListener('click', () => {
      goPrev()
      navActivity()
      dotActivity()
    })

    next.addEventListener('click', () => {
      goNext()
      navActivity()
      dotActivity()
    })

    ;[...dots].forEach( (dot, index) => {
      dot.addEventListener('click', () => {
        goTo(index)
        navActivity()
        dotActivity()
      })
    })

    document.addEventListener('keydown', (e) => {
      if (e.keyCode === 39) {
        goNext()
        navActivity()
        dotActivity()
      }
      if (e.keyCode === 37) {
        goPrev()
        navActivity()
        dotActivity()
      }
    })

    // Helper functions
    function setTransform() {
      slider.style['transform'] = 'translate3d(' + (-pos * slideWidth) + 'px,0,0)'
    }

    function goPrev() {
      if (pos > 0) {
        pos = Math.max(pos - 1, 0)
        setTransform()
      }
    }
    
    function goNext() {
      if ( pos < slidesCount ) {
        pos = Math.min(pos + 1, slidesCount - 1)
        setTransform()
      }
    }

    function goTo(index) {
      pos = Math.max(index)
      setTransform()
    }

    function navActivity() {
      if (pos > 0) {
        if ( prev.classList.contains('inactive')) {
          prev.classList.remove('inactive')
        }
      } else {
        if (! prev.classList.contains('inactive')) {
          prev.classList.add('inactive')
        }
      }

      if ( pos + 1 < slidesCount ) {
        if (next.classList.contains('inactive')) {
          next.classList.remove('inactive')
        }
      } else {
        if (! next.classList.contains('inactive')) {
          next.classList.add('inactive')
        }
      }
    }

    function dotActivity() {
      ;[...dots].forEach( (dot, index) => {
        if (index === pos) {
          if (! dot.classList.contains('active')) {
            dot.classList.add('active')
          }
        } else {
          if (dot.classList.contains('active')) {
            dot.classList.remove('active')
          }
        }
      })
    }

  }) // end foreach

}


// WEBPACK FOOTER //
// ./src/js/modules/SwipeOneSlider.js